import 'babel-polyfill';

import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App';

import routesConfig from '../routes';

Vue.config.productionTip = false;
Vue.use(VueRouter);

const generateRoutes = x => {
    let routes = x.routes.map(item => {
        let obj = {
            path: item.path,
            name: item.name,
            component: function(resolve) {
                require(['.' + item.component], resolve);
            }
        };
        if (item.routes) {
            obj.children = generateRoutes(item);
        }
        if (item.alias) {
            obj.alias = item.alias;
        }
        if (item.meta) {
            obj.meta = Object.assign({}, item.meta);
        }
        return obj;
    });
    return routes;
};

if (location.host === 'www.bijiagou.com') {
    routesConfig.routes[0] = {
        "name": "index",
        "path": "/",
        "component": "/pages/AppDownload.vue",
        "meta": {
            "title": "比价狗APP——手机上的购物比价插件"
        }
    }
}

console.log(routesConfig)

let routes = generateRoutes(routesConfig);

const router = new VueRouter({
    routes: routes,
    saveScrollPosition: true,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (location.href.includes('goDown')) {
            return {
                top: 9999
            }
        }
        return savedPosition
    }
});

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

/* eslint-disable no-new */
document.addEventListener('DOMContentLoaded', () => {
    new Vue({
        el: '#app',
        render: h => h(App),
        router
    });
});



// WEBPACK FOOTER //
// ./src/main.js